export { type FsrsCard, fsrsCardTable } from "#fsrs-card-table";
